import { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { LayoutDashboard, Euro, Receipt, UtensilsCrossed, ChefHat, Users, Wrench, TrendingUp, Camera, Trash2, ClipboardList, CalendarDays, PenLine, Wallet, Send, Settings, LogOut, ChevronLeft, ChevronRight, Menu, X, ShoppingCart, PieChart, Sun, Moon, Landmark, Brain, Sparkles, Package, Palmtree, Gift, Snowflake, BookOpen, Calculator, CircleDot, Contact, ChevronDown, UserCog, Bot, Mail, Globe, Grid3X3, Target, Search, Link, BarChart3, FileText, Zap, Clock, CheckSquare } from 'lucide-react';
import { useTheme } from '../../hooks/useTheme';
import { Input } from '../ui/input';

const PATRON_SECTIONS = [
  {
    label: 'Pilotage',
    items: [
      { id: 'dashboard', icon: LayoutDashboard, label: 'Accueil' },
      { id: 'gestion', icon: Settings, label: 'Gestion' },
      { id: 'tresorerie', icon: Wallet, label: 'Tresorerie' },
      { id: 'budget', icon: Calculator, label: 'Budget' },
      { id: 'previsionnel', icon: TrendingUp, label: 'Previsionnel' },
      { id: 'taches', icon: CheckSquare, label: 'Taches' },
    ],
  },
  {
    label: 'Activite',
    items: [
      { id: 'ca', icon: Euro, label: 'Chiffre d\'affaires' },
      { id: 'saisie', icon: PenLine, label: 'Saisie' },
      { id: 'suivi', icon: CalendarDays, label: 'Bilan' },
      { id: 'factures', icon: Receipt, label: 'Factures' },
    ],
  },
  {
    label: 'Restaurant',
    items: [
      { id: 'menu', icon: BookOpen, label: 'Menu' },
      { id: 'menu-du-jour', icon: CalendarDays, label: 'Menu du Jour' },
      { id: 'carte', icon: UtensilsCrossed, label: 'Food Cost' },
      { id: 'mercuriales', icon: ClipboardList, label: 'Mercuriales' },
      { id: 'traiteur', icon: ChefHat, label: 'Traiteur' },
      { id: 'congelateur', icon: Snowflake, label: 'Congelateur' },
    ],
  },
  {
    label: 'Commercial',
    items: [
      { id: 'clients', icon: Contact, label: 'Clients' },
      { id: 'reservations', icon: CalendarDays, label: 'Reservations' },
      { id: 'resa-calendar', icon: CalendarDays, label: 'Calendrier' },
      { id: 'resa-floor-plan', icon: LayoutDashboard, label: 'Plan de salle' },
      { id: 'resa-customers', icon: Users, label: 'Clients resa' },
      { id: 'resa-menu', icon: UtensilsCrossed, label: 'Carte resto' },
      { id: 'resa-settings', icon: Settings, label: 'Param. resa' },
      { id: 'roue', icon: CircleDot, label: 'Jeu fidelite' },
      { id: 'bons-cadeaux', icon: Gift, label: 'Bons Cadeaux' },
    ],
  },
  {
    label: 'Propositions',
    items: [
      { id: 'prop-dashboard', icon: FileText, label: 'Suivi Commercial' },
      { id: 'prop-pipeline', icon: Target, label: 'Pipeline' },
      { id: 'prop-veille', icon: TrendingUp, label: 'Veille & Marché' },
    ],
  },
  {
    label: 'Prospection',
    items: [
      { id: 'crm-dashboard', icon: BarChart3, label: 'Tableau de bord' },
      { id: 'crm-rapide', icon: Zap, label: 'Rapide' },
      { id: 'crm-relances', icon: Clock, label: 'Relances' },
      { id: 'crm-pipeline', icon: Target, label: 'Pipeline' },
      { id: 'crm-signatures', icon: PenLine, label: 'Signatures' },
      { id: 'crm-recherche', icon: Search, label: 'Recherche' },
      { id: 'crm-sources', icon: Link, label: 'Sources API' },
      { id: 'crm-config', icon: Settings, label: 'Config / Catalogue' },
    ],
  },
  {
    label: 'Gestion',
    items: [
      { id: 'salaires', icon: Users, label: 'Salaires' },
      { id: 'conges', icon: Palmtree, label: 'Conges' },
      { id: 'fixes', icon: Wrench, label: 'Charges fixes' },
      { id: 'pertes', icon: Trash2, label: 'Pertes' },
      { id: 'banques', icon: Landmark, label: 'Banques' },
      { id: 'rapprochement', icon: PieChart, label: 'Rapprochement' },
      { id: 'prop-dashboard', icon: FileText, label: 'Propositions' },
    ],
  },
  {
    label: 'Outils',
    items: [
      { id: 'ia-cowork', icon: Bot, label: 'IA Cowork' },
      { id: 'messagerie', icon: Mail, label: 'Messagerie' },
      { id: 'admin-site', icon: Globe, label: 'Gestion Site' },
      { id: 'users', icon: UserCog, label: 'Acces' },
      { id: 'optimisation', icon: Brain, label: 'Optim IA' },
      { id: 'telegram', icon: Send, label: 'Telegram' },
      { id: 'settings-chef', icon: Settings, label: 'Chef' },
    ],
  },
];

const CHEF_TABS = [
  { id: 'budget', icon: Euro, label: 'Budget' },
  { id: 'factures', icon: Camera, label: 'Factures' },
  { id: 'pertes', icon: Trash2, label: 'Pertes' },
  { id: 'commande', icon: ShoppingCart, label: 'Commande' },
  { id: 'menus-groupe', icon: ChefHat, label: 'Menus Groupe' },
  { id: 'couts', icon: PieChart, label: 'Couts' },
  { id: 'manuel', icon: ClipboardList, label: 'Manuel' },
  { id: 'carte', icon: UtensilsCrossed, label: 'Carte' },
  { id: 'mercuriales', icon: Package, label: 'Mercuriales' },
  { id: 'recettes', icon: Sparkles, label: 'Recettes Mas' },
  { id: 'congelateur', icon: Snowflake, label: 'Congelateur' },
];

export const SideNav = ({ activeTab, setActiveTab, role = 'patron', onLogout, chefAccess = null }) => {
  const navigate = useNavigate();
  const [collapsed, setCollapsed] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [persoUnlocked, setPersoUnlocked] = useState(false);
  const [showPersoCode, setShowPersoCode] = useState(false);
  const [persoCode, setPersoCode] = useState('');
  const [openSections, setOpenSections] = useState({});
  const [pendingCount, setPendingCount] = useState(0);
  const { theme, toggle } = useTheme();

  // Check for pending access requests
  useEffect(() => {
    if (role !== 'patron') return;
    const checkPending = async () => {
      try {
        const token = localStorage.getItem('token');
        const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/auth/users`, {
          headers: { 'Authorization': `Bearer ${token}` }
        });
        if (res.ok) {
          const users = await res.json();
          setPendingCount(users.filter(u => u.status === 'pending').length);
        }
      } catch {}
    };
    checkPending();
    const interval = setInterval(checkPending, 60000);
    return () => clearInterval(interval);
  }, [role]);

  // Auto-open section that contains the active tab
  useEffect(() => {
    if (role !== 'patron') return;
    for (const section of PATRON_SECTIONS) {
      if (section.items.some(item => item.id === activeTab)) {
        setOpenSections(prev => ({ ...prev, [section.label]: true }));
        break;
      }
    }
  }, [activeTab, role]);

  const toggleSection = (label) => {
    if (collapsed) return;
    setOpenSections(prev => ({ ...prev, [label]: !prev[label] }));
  };

  const handlePilotageDoubleClick = useCallback(() => {
    if (role !== 'patron') return;
    if (persoUnlocked) {
      setActiveTab('perso');
      setMobileOpen(false);
    } else {
      setShowPersoCode(true);
    }
  }, [role, persoUnlocked, setActiveTab]);

  const handlePersoCodeSubmit = useCallback(() => {
    if (persoCode === '112118') {
      setPersoUnlocked(true);
      setShowPersoCode(false);
      setPersoCode('');
      setActiveTab('perso');
      setMobileOpen(false);
    } else {
      setPersoCode('');
    }
  }, [persoCode, setActiveTab]);

  const accentColor = role === 'patron' ? 'rgb(var(--lm-gold))' : 'rgb(var(--lm-green))';

  const chefTabs = chefAccess?.pages
    ? CHEF_TABS.filter(tab => { const page = chefAccess.pages[tab.id]; return !page || page.enabled !== false; })
    : CHEF_TABS;

  useEffect(() => {
    if (mobileOpen) document.body.style.overflow = 'hidden';
    else document.body.style.overflow = '';
    return () => { document.body.style.overflow = ''; };
  }, [mobileOpen]);

  const handleTabClick = (id) => {
    setActiveTab(id);
    setMobileOpen(false);
  };

  const navContent = (
    <div className="flex flex-col h-full">
      {/* Logo */}
      <div className="px-4 py-3 border-b border-[rgb(var(--lm-border))]" data-testid="nav-logo">
        <div className="flex items-center gap-3">
          {!collapsed ? (
            <div>
              <div className="flex items-center gap-2">
                <span className="text-xs font-mono tracking-[0.3em] uppercase" style={{ color: accentColor }}>
                  Le Mas
                </span>
              </div>
              <span
                className="text-[9px] tracking-[0.15em] uppercase text-[rgb(var(--lm-text-muted))] cursor-default select-none"
                onDoubleClick={handlePilotageDoubleClick}
                data-testid="pilotage-label"
              >
                {role === 'patron' ? 'Pilotage' : 'Cuisine'}
              </span>
              {showPersoCode && (
                <div className="mt-2" onClick={e => e.stopPropagation()}>
                  <Input
                    type="password"
                    value={persoCode}
                    onChange={e => setPersoCode(e.target.value)}
                    onKeyDown={e => { if (e.key === 'Enter') handlePersoCodeSubmit(); }}
                    className="h-7 w-full bg-[rgb(var(--lm-bg))] border-[rgb(var(--lm-border))] text-xs font-mono text-center"
                    placeholder="Code"
                    autoFocus
                    maxLength={6}
                    data-testid="perso-code-input"
                  />
                </div>
              )}
            </div>
          ) : (
            <span
              className="text-sm font-mono font-bold cursor-default select-none"
              style={{ color: accentColor }}
              onDoubleClick={handlePilotageDoubleClick}
            >
              LM
            </span>
          )}
        </div>
      </div>

      {/* Bouton Centre de Gestion */}
      {role === 'patron' && (
        <button
          onClick={() => navigate('/hub')}
          className="mx-2 mt-1 mb-1 flex items-center gap-2 px-3 py-1.5 rounded-md bg-[rgb(var(--lm-gold)/0.08)] hover:bg-[rgb(var(--lm-gold)/0.15)] transition-colors"
          data-testid="back-to-hub"
        >
          <Grid3X3 size={12} style={{ color: accentColor }} />
          {!collapsed && <span className="text-[10px] font-medium" style={{ color: accentColor }}>Centre de gestion</span>}
        </button>
      )}

      {/* Navigation */}
      <div className="flex-1 overflow-y-auto py-2 px-2">
        {role === 'patron' ? (
          /* Patron: Categorized sections */
          <div className="space-y-0.5">
            {PATRON_SECTIONS.map(section => {
              const isOpen = openSections[section.label] ?? false;
              const hasActive = section.items.some(item => item.id === activeTab);

              return (
                <div key={section.label}>
                  {/* Section header */}
                  <button
                    onClick={() => toggleSection(section.label)}
                    className={`w-full flex items-center justify-between px-3 py-1.5 rounded-sm transition-all ${
                      hasActive && !isOpen
                        ? 'text-[rgb(var(--lm-gold))]'
                        : 'text-[rgb(var(--lm-text-muted))] hover:text-[rgb(var(--lm-text-secondary))]'
                    }`}
                    data-testid={`section-${section.label.toLowerCase()}`}>
                    {!collapsed && (
                      <>
                        <span className="text-[9px] tracking-[0.15em] uppercase font-medium">{section.label}</span>
                        <div className="flex items-center gap-1">
                          {section.label === 'Outils' && pendingCount > 0 && (
                            <span className="w-4 h-4 rounded-full bg-red-500 text-white text-[8px] font-bold flex items-center justify-center animate-pulse" data-testid="pending-badge">{pendingCount}</span>
                          )}
                          <ChevronDown size={10} className={`transition-transform duration-200 ${isOpen ? 'rotate-0' : '-rotate-90'}`} />
                        </div>
                      </>
                    )}
                    {collapsed && (
                      <span className="text-[8px] tracking-wider uppercase w-full text-center opacity-40">{section.label.slice(0, 3)}</span>
                    )}
                  </button>

                  {/* Section items */}
                  {(isOpen || collapsed) && (
                    <div className={`space-y-0 ${collapsed ? '' : 'ml-1 border-l border-[rgb(var(--lm-border)/0.3)] pl-1'}`}>
                      {section.items.map(tab => {
                        const Icon = tab.icon;
                        const isActive = activeTab === tab.id;
                        return (
                          <button key={tab.id}
                            onClick={() => handleTabClick(tab.id)}
                            className={`w-full flex items-center gap-2 px-3 py-1.5 rounded-sm text-left transition-all duration-150 ${
                              isActive
                                ? 'bg-[rgb(var(--lm-gold)/0.08)]'
                                : 'hover:bg-[rgb(var(--lm-surface-elevated))]'
                            }`}
                            style={isActive ? { color: accentColor } : { color: 'rgb(var(--lm-text-secondary))' }}
                            data-testid={`nav-${tab.id}`}>
                            <Icon size={13} strokeWidth={isActive ? 2 : 1.5} />
                            {!collapsed && (
                              <span className={`text-[12px] ${isActive ? 'font-semibold' : 'font-normal'} flex-1`}>
                                {tab.label}
                              </span>
                            )}
                            {!collapsed && tab.id === 'users' && pendingCount > 0 && (
                              <span className="w-4 h-4 rounded-full bg-red-500 text-white text-[8px] font-bold flex items-center justify-center">{pendingCount}</span>
                            )}
                          </button>
                        );
                      })}
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        ) : (
          /* Chef: Flat list */
          <div className="space-y-0.5">
            {chefTabs.map(tab => {
              const Icon = tab.icon;
              const isActive = activeTab === tab.id;
              return (
                <button key={tab.id}
                  onClick={() => handleTabClick(tab.id)}
                  className={`w-full flex items-center gap-3 px-3 py-2.5 rounded-sm text-left transition-all duration-200 ${
                    isActive
                      ? 'bg-[rgb(var(--lm-gold)/0.08)] border-l-2'
                      : 'border-l-2 border-transparent hover:bg-[rgb(var(--lm-surface-elevated))]'
                  }`}
                  style={isActive ? { borderLeftColor: accentColor, color: accentColor } : { color: 'rgb(var(--lm-text-secondary))' }}
                  data-testid={`nav-${tab.id}`}>
                  <Icon size={16} strokeWidth={isActive ? 2 : 1.5} />
                  {!collapsed && (
                    <span className={`text-sm ${isActive ? 'font-semibold' : 'font-normal'}`}>
                      {tab.label}
                    </span>
                  )}
                </button>
              );
            })}
          </div>
        )}
      </div>

      {/* Bottom actions */}
      <div className="border-t border-[rgb(var(--lm-border))] p-3 space-y-1">
        <button onClick={toggle}
          className="w-full flex items-center gap-3 px-3 py-2 rounded-sm text-[rgb(var(--lm-text-secondary))] hover:bg-[rgb(var(--lm-surface-elevated))] transition-all duration-200"
          data-testid="theme-toggle">
          {theme === 'dark' ? <Sun size={16} strokeWidth={1.5} /> : <Moon size={16} strokeWidth={1.5} />}
          {!collapsed && <span className="text-sm">{theme === 'dark' ? 'Mode clair' : 'Mode sombre'}</span>}
        </button>

        <button onClick={() => setCollapsed(!collapsed)}
          className="hidden md:flex w-full items-center gap-3 px-3 py-2 rounded-sm text-[rgb(var(--lm-text-muted))] hover:text-[rgb(var(--lm-text-secondary))] transition-colors"
          data-testid="collapse-nav">
          {collapsed ? <ChevronRight size={16} /> : <ChevronLeft size={16} />}
          {!collapsed && <span className="text-xs">Reduire</span>}
        </button>

        {onLogout && (
          <button onClick={onLogout}
            className="w-full flex items-center gap-3 px-3 py-2 rounded-sm text-[rgb(var(--lm-text-muted))] hover:text-[rgb(var(--lm-red))] transition-colors"
            data-testid="logout-btn">
            <LogOut size={16} strokeWidth={1.5} />
            {!collapsed && <span className="text-sm">Deconnexion</span>}
          </button>
        )}
      </div>
    </div>
  );

  return (
    <>
      {/* Mobile hamburger */}
      <button onClick={() => setMobileOpen(!mobileOpen)}
        className="md:hidden fixed top-3 left-3 z-50 p-2.5 rounded-sm lm-card"
        style={{ color: accentColor }}
        data-testid="mobile-menu-btn">
        {mobileOpen ? <X size={18} /> : <Menu size={18} />}
      </button>

      {/* Mobile overlay */}
      {mobileOpen && (
        <div className="md:hidden fixed inset-0 z-40 bg-black/60 backdrop-blur-sm"
          onClick={() => setMobileOpen(false)} />
      )}

      {/* Mobile drawer */}
      <nav className={`md:hidden fixed top-0 left-0 z-40 h-full bg-[rgb(var(--lm-surface))] border-r border-[rgb(var(--lm-border))] transition-transform duration-300 ${
        mobileOpen ? 'translate-x-0 w-64' : '-translate-x-full w-64'
      }`}>
        {navContent}
      </nav>

      {/* Desktop sidebar */}
      <nav className={`hidden md:flex fixed top-0 left-0 h-full flex-col bg-[rgb(var(--lm-surface))] border-r border-[rgb(var(--lm-border))] z-30 transition-all duration-300 ${
        collapsed ? 'w-16' : 'w-52'
      }`}>
        {navContent}
      </nav>
    </>
  );
};
